import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'NavIconSvg',
  props: {
  width: {
    type: [String, Number],
    default: 16,
  },
  height: {
    type: [String, Number],
    default: 12,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12",
    fill: "none"
  }, _ctx.$attrs, {
    width: __props.width,
    height: __props.height
  }), [
    _createElementVNode("path", {
      d: "M0 5H12V7H0V5ZM0 0H16V2H0V0ZM0 12H7.235V10H0V12Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})